// import constant
import {
    SET_AUTH_ACCOUNT,
    REMOVE_AUTH_ACCOUNT
} from '../constant';

const initialValue = {
    isAuth: false
}

const account = (state = initialValue, action) => {
    switch (action.type) {
        case SET_AUTH_ACCOUNT:
            return {
                ...state,
                ...action.data
            };
        case REMOVE_AUTH_ACCOUNT:
            return initialValue;
        default:
            return state;
    }
}

export const setAuthAccount = (dispatch, data) => {
    return dispatch({ type: SET_AUTH_ACCOUNT, data: { ...data, ...{ isAuth: true } } })
}

export const removeAuthAccount = (dispatch) => {
    return dispatch({ type: REMOVE_AUTH_ACCOUNT })
}

export default account;
